import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

// menu item imports
import { designerOptionsMenuItem } from '../menu-item/designer-options-menu-item';
import { dimensionOrientationSubmenuMenuItem } from '../menu-item/dimension-orientation-submenu-menu-item';
import { displayModeMenuItem } from '../menu-item/display-mode-menu-item';
import { islandPropertiesMenuItem } from '../menu-item/island-properties-menu-item';
import { kitchenPropertiesMenuItem } from '../menu-item/kitchen-properties-menu-item';
import { rotateKitchenMenuItem } from '../menu-item/rotate-kitchen-menu-item';
import { showAllDimensionsMenuItem } from '../menu-item/show-all-dimensions-menu-item';

export const workspaceMenuList: Array<ContextMenuList> = [
	displayModeMenuItem(),
	rotateKitchenMenuItem(),
	{ type: ContextMenuListItemType.Divider },
	islandPropertiesMenuItem(),
	kitchenPropertiesMenuItem(),
	{ type: ContextMenuListItemType.Divider },
	dimensionOrientationSubmenuMenuItem(),
	showAllDimensionsMenuItem(),
	{ type: ContextMenuListItemType.Divider },
	designerOptionsMenuItem()
];
